<adm-type-ahead-selector2
  label="Fallback prispolitik"
  [itemTemplate]="itemTemplate()"
  [fetchFn]="fetchPricePolicies"
  [fetchByIdFn]="fetchPricePolicyById"
  [initialId]="config().pricePolicyId?.toString() ?? undefined"
  [disabled]="disabled()"
  (itemSelected)="pricePolicySelected($event)"
  identityPropertyName="id"
  [resetTrigger]="resetTrigger()" />
